/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
/**
 * Specifies the action buttons of the Card.
 * * ([see example]({% slug actions_card %})).
 */
var CardActionsComponent = /** @class */ (function () {
    function CardActionsComponent() {
        this.hostClass = true;
        /**
         * Specifies the layout of the Card action buttons.
         *
         * * The possible values are:
         * * (Default) `horizontal`
         * * `vertical`
         *
         */
        this.orientation = 'horizontal';
        /**
         * Specifies the layout of the Card action buttons.
         *
         * The possible values are:
         * * (Default) `start`
         * * `center`
         * * `end`
         * * `stretched`
         *
         */
        this.layout = 'start';
        /**
         * Fires when the user clicks an action button.
         */
        this.action = new core_1.EventEmitter();
    }
    Object.defineProperty(CardActionsComponent.prototype, "stretchedClass", {
        get: function () {
            return this.layout === 'stretched';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardActionsComponent.prototype, "startClass", {
        get: function () {
            return this.layout === 'start';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardActionsComponent.prototype, "endClass", {
        get: function () {
            return this.layout === 'end';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardActionsComponent.prototype, "centerClass", {
        get: function () {
            return this.layout === 'center';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardActionsComponent.prototype, "verticalClass", {
        get: function () {
            return this.orientation === 'vertical';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CardActionsComponent.prototype, "horizontalClass", {
        get: function () {
            return this.orientation === 'horizontal';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    CardActionsComponent.prototype.onClick = function (action) {
        this.action.emit(action);
    };
    /**
     * @hidden
     */
    CardActionsComponent.prototype.actionTemplate = function () {
        return this.actions instanceof core_1.TemplateRef;
    };
    tslib_1.__decorate([
        core_1.HostBinding('class.k-card-actions'),
        tslib_1.__metadata("design:type", Boolean)
    ], CardActionsComponent.prototype, "hostClass", void 0);
    tslib_1.__decorate([
        core_1.HostBinding('class.k-card-actions-stretched'),
        tslib_1.__metadata("design:type", Boolean),
        tslib_1.__metadata("design:paramtypes", [])
    ], CardActionsComponent.prototype, "stretchedClass", null);
    tslib_1.__decorate([
        core_1.HostBinding('class.k-card-actions-start'),
        tslib_1.__metadata("design:type", Boolean),
        tslib_1.__metadata("design:paramtypes", [])
    ], CardActionsComponent.prototype, "startClass", null);
    tslib_1.__decorate([
        core_1.HostBinding('class.k-card-actions-end'),
        tslib_1.__metadata("design:type", Boolean),
        tslib_1.__metadata("design:paramtypes", [])
    ], CardActionsComponent.prototype, "endClass", null);
    tslib_1.__decorate([
        core_1.HostBinding('class.k-card-actions-center'),
        tslib_1.__metadata("design:type", Boolean),
        tslib_1.__metadata("design:paramtypes", [])
    ], CardActionsComponent.prototype, "centerClass", null);
    tslib_1.__decorate([
        core_1.HostBinding('class.k-card-actions-vertical'),
        tslib_1.__metadata("design:type", Boolean),
        tslib_1.__metadata("design:paramtypes", [])
    ], CardActionsComponent.prototype, "verticalClass", null);
    tslib_1.__decorate([
        core_1.HostBinding('class.k-card-actions-horizontal'),
        tslib_1.__metadata("design:type", Boolean),
        tslib_1.__metadata("design:paramtypes", [])
    ], CardActionsComponent.prototype, "horizontalClass", null);
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", String)
    ], CardActionsComponent.prototype, "orientation", void 0);
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", String)
    ], CardActionsComponent.prototype, "layout", void 0);
    tslib_1.__decorate([
        core_1.Input(),
        tslib_1.__metadata("design:type", Object)
    ], CardActionsComponent.prototype, "actions", void 0);
    tslib_1.__decorate([
        core_1.Output(),
        tslib_1.__metadata("design:type", core_1.EventEmitter)
    ], CardActionsComponent.prototype, "action", void 0);
    CardActionsComponent = tslib_1.__decorate([
        core_1.Component({
            selector: 'kendo-card-actions',
            template: "\n        <ng-content *ngIf=\"!actions\"></ng-content>\n\n        <ng-container *ngIf=\"!actionTemplate()\">\n            <button type=\"button\"\n                class=\"k-button\"\n                [class.k-primary]=\"action.primary\"\n                [class.k-flat]=\"action.flat\"\n                (click)=\"onClick(action)\"\n                *ngFor=\"let action of actions\"\n            >\n                {{ action.text }}\n            </button>\n        </ng-container>\n\n        <ng-template [ngTemplateOutlet]=\"actions\" *ngIf=\"actionTemplate()\"></ng-template>\n    "
        })
    ], CardActionsComponent);
    return CardActionsComponent;
}());
exports.CardActionsComponent = CardActionsComponent;
